import { useState, useEffect } from "react";
import { Users, Building2, CalendarDays, ClipboardCheck, Megaphone, CalendarClock } from "lucide-react";
import { useLang } from "@/lib/i18n";
import api from "@/lib/api";

export const AdminOverview = ({ assoc }) => {
  const { t } = useLang();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get(`/associations/${assoc.slug}/stats`).then(({ data }) => setStats(data)).catch(() => {});
  }, [assoc.slug]);

  const cards = [
    { icon: Users, label: t("members"), value: stats?.members },
    { icon: Building2, label: t("mosques"), value: stats?.mosques },
    { icon: CalendarDays, label: t("events"), value: stats?.events },
    { icon: CalendarClock, label: t("upcoming_events"), value: stats?.upcoming_events },
    { icon: ClipboardCheck, label: t("total_registrations"), value: stats?.registrations },
    { icon: Megaphone, label: t("announcements"), value: stats?.announcements },
  ];

  return (
    <div>
      <h1 className="font-heading font-extrabold text-2xl tracking-tight mb-8">{t("overview")}</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-stats-grid">
        {cards.map((c) => (
          <div key={c.label} className="border border-border rounded-lg bg-card p-5">
            <c.icon className="h-4 w-4 text-accent" />
            <p className="font-mono-data font-bold text-3xl mt-3">{c.value ?? "—"}</p>
            <p className="text-xs text-muted-foreground mt-1 capitalize">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
